import React from 'react'
import { IUser } from '@/model/types/user'
import { createUseStyles } from 'react-jss'
import { Row } from '../layout/layout'

const styles = createUseStyles({
    avatar: {
        marginRight: '8px',
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: '#ddd',
        flexShrink: 0,
        'vertical-align': 'bottom',
        border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    avatar0: {
        border: '1px solid #3c90ff',
    },
    avatar1: {},
    name: {
        display: 'inline',
    },
})

interface IProps {
    userInfo: IUser
}

export const UserInfo: React.FC<IProps> = props => {
    const classes = styles()

    return (
        <Row data-align-items-center>
            <img src={props.userInfo.avatar} className={classes.avatar} alt=""></img>
            <span className={['text-popper', classes.name].join(' ')}>
                {props.userInfo.realname || props.userInfo.nickname}
            </span>
        </Row>
    )
}
